import { render, staticRenderFns } from "./InformationMian.vue?vue&type=template&id=2dc23187&scoped=true"
import script from "./InformationMian.vue?vue&type=script&lang=js"
export * from "./InformationMian.vue?vue&type=script&lang=js"
import style0 from "./InformationMian.vue?vue&type=style&index=0&id=2dc23187&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc23187",
  null
  
)

export default component.exports